module.exports = {
    widgetUrl: 'https://www.doctify.com',
    widgetV2Url: 'https://www.doctify.com/wv2',
    apiUrl: 'https://www.doctify.com/',
    dashboardUrl: 'https://dashboard.doctify.com/'
};
